module.exports = __webpack_public_path__ + "img/tablet-ipad-efb.4e36d9f8.svg";